export const SET_CONFIGS = 'SET_CONFIGS';
export const UPDATE_CONFIGS = 'UPDATE_CONFIGS';